import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Container = styled.div`
  display: flex;
  column-gap: 8px;
  transition: 0.3s;

  &[aria-disabled='true'] {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const CellInput = styled.input<{ $hasError?: boolean }>`
  height: 34px;
  width: 34px;
  padding: 0;
  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      ct({
        Dark: props.$hasError ? Colors.RedMiddle : Colors.GreyDarkerMiddle,
        Light: props.$hasError ? Colors.RedMiddle : Colors.GreyDarkerMiddle,
      })};
  background: ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.White })};
  color: ${ct({ Dark: Colors.White, Light: Colors.Darkest })};
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  outline: none;
`;
